<template>
    <nav v-click-outside="closeMenu" class="the-nav">
        <div class="nav-logo" @click="goHome">
            <img :src="$asset('images/misc/logo.png')" alt="Infinity88" />
        </div>
        <div class="nav-actions">
            <div v-if="loggedIn" class="nav-user-btns">
                <app-button v-if="$modules.has('deposit')" class="desktop-only" @click="$router.push('/deposit')">{{ $t('nav.deposit') }}</app-button>
                <div class="btn-wallet-group desktop-only">
                    <nav-wallet />
                    <nav-currency-select />
                </div>
            </div>
            <div v-else class="nav-btns desktop-only">
                <app-button variant="cta" @click="$root.$emit('open-register')">{{ $t('nav.signUp') }}</app-button>
                <app-button variant="outline" @click="$root.$emit('open-login')">{{ $t('nav.login') }}</app-button>
            </div>

            <div class="nav-extras">
                <nav-currency-select v-if="loggedIn" compact />
                <nav-language-select />
                <div class="divider-v"></div>
                <app-icon-button :size="34" @click.stop="menuOpen = !menuOpen">
                    <svg class="menu-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M1.99992 5.33333H13.9999C14.1767 5.33333 14.3463 5.2631 14.4713 5.13807C14.5963 5.01305 14.6666 4.84348 14.6666 4.66667C14.6666 4.48986 14.5963 4.32029 14.4713 4.19526C14.3463 4.07024 14.1767 4 13.9999 4H1.99992C1.82311 4 1.65354 4.07024 1.52851 4.19526C1.40349 4.32029 1.33325 4.48986 1.33325 4.66667C1.33325 4.84348 1.40349 5.01305 1.52851 5.13807C1.65354 5.2631 1.82311 5.33333 1.99992 5.33333V5.33333ZM13.9999 10.6667H1.99992C1.82311 10.6667 1.65354 10.7369 1.52851 10.8619C1.40349 10.987 1.33325 11.1565 1.33325 11.3333C1.33325 11.5101 1.40349 11.6797 1.52851 11.8047C1.65354 11.9298 1.82311 12 1.99992 12H13.9999C14.1767 12 14.3463 11.9298 14.4713 11.8047C14.5963 11.6797 14.6666 11.5101 14.6666 11.3333C14.6666 11.1565 14.5963 10.987 14.4713 10.8619C14.3463 10.7369 14.1767 10.6667 13.9999 10.6667ZM13.9999 7.33333H1.99992C1.82311 7.33333 1.65354 7.40357 1.52851 7.5286C1.40349 7.65362 1.33325 7.82319 1.33325 8C1.33325 8.17681 1.40349 8.34638 1.52851 8.4714C1.65354 8.59643 1.82311 8.66667 1.99992 8.66667H13.9999C14.1767 8.66667 14.3463 8.59643 14.4713 8.4714C14.5963 8.34638 14.6666 8.17681 14.6666 8C14.6666 7.82319 14.5963 7.65362 14.4713 7.5286C14.3463 7.40357 14.1767 7.33333 13.9999 7.33333Z" fill="currentColor"/>
                    </svg>
                </app-icon-button>
            </div>
        </div>

        <transition name="menu-drop">
            <nav-user-menu v-if="menuOpen && loggedIn" @close="closeMenu" />
        </transition>
    </nav>
</template>

<script>
import NavWallet from './nav/NavWallet.vue';
import NavCurrencySelect from './nav/NavCurrencySelect.vue';
import NavLanguageSelect from './nav/NavLanguageSelect.vue';
import NavUserMenu from './nav/NavUserMenu.vue';

export default {
    name: 'TheNav',
    components: { NavWallet, NavCurrencySelect, NavLanguageSelect, NavUserMenu },
    data() {
        return { menuOpen: false };
    },
    computed: {
        loggedIn() {
            return this.$sharedState.loggedIn;
        }
    },
    methods: {
        goHome() {
            if (this.$route.path !== '/') this.$router.push('/');
        },
        closeMenu() {
            this.menuOpen = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.the-nav {
    width: 100%;
    background: var(--surface-0);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 40px 14px calc(var(--sidebar-width, 64px) + 36px);
    position: sticky;
    top: 0;
    z-index: 100;
    transition: padding-left 0.3s ease;

    @media (max-width: 768px) {
        padding: 8px 20px;
    }
}

.nav-logo {
    cursor: pointer;

    img {
        height: 32px;
        width: auto;

        @media (max-width: 768px) {
            height: 32px;
        }
    }
}

.nav-actions,
.nav-user-btns,
.nav-btns {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
}

.desktop-only {
    @media (max-width: 768px) {
        display: none !important;
    }
}

.btn-wallet-group {
    display: flex;
    align-items: center;
    min-width: 0;
}

.nav-extras {
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;
    flex-shrink: 0;
    margin-left: auto;
}

.divider-v {
    width: 1px;
    height: 16px;
    background: color-mix(in srgb, var(--white) 20%, transparent);
}

.menu-icon {
    color: var(--icon-muted);
}

.menu-drop-enter-active,
.menu-drop-leave-active {
    transition: opacity 0.15s ease, transform 0.15s ease;
}

.menu-drop-enter,
.menu-drop-leave-to {
    opacity: 0;
    transform: translateY(-6px);
}
</style>
